var _rect, _rect2, _text, _text2, _defs, _g, _text3, _text4, _text5, _text6, _text7, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect3, _text8, _path9, _path0, _rect4, _text9, _path1, _path10, _rect5, _text0, _text1, _text10, _text11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJiraBugLifecycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 720,
    viewBox: "0 0 1200 720",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 720,
    rx: 36,
    fill: "#F8FBFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 42,
    width: 1116,
    height: 636,
    rx: 28,
    fill: "white",
    stroke: "#D7E6FF",
    strokeWidth: 4
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 110,
    fill: "#173E9F",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 40,
    fontWeight: 700
  }, "JIRA Bug Lifecycle for QA")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 148,
    fill: "#51607A",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 24
  }, "From initial report to closure with retest and reopen handling")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: 0,
    y: 0,
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 12,
    stdDeviation: 12,
    floodColor: "#173E9F",
    floodOpacity: 0.08
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 226,
    width: 144,
    height: 88,
    rx: 20,
    fill: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 226,
    width: 144,
    height: 88,
    rx: 20,
    fill: "#FFF1E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458,
    y: 226,
    width: 168,
    height: 88,
    rx: 20,
    fill: "#E9FBF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 668,
    y: 226,
    width: 144,
    height: 88,
    rx: 20,
    fill: "#FFF8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 854,
    y: 226,
    width: 144,
    height: 88,
    rx: 20,
    fill: "#E9F2FF"
  }))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 278,
    fill: "#173E9F",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 30,
    fontWeight: 700
  }, "New")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 294,
    y: 278,
    fill: "#B85A1A",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 30,
    fontWeight: 700
  }, "Assigned")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 495,
    y: 278,
    fill: "#1A7F52",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 28,
    fontWeight: 700
  }, "In Progress")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 707,
    y: 278,
    fill: "#866300",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 30,
    fontWeight: 700
  }, "Fixed")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 893,
    y: 278,
    fill: "#173E9F",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 30,
    fontWeight: 700
  }, "Retest")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M230 270H270",
    stroke: "#173E9F",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M416 270H456",
    stroke: "#173E9F",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M626 270H666",
    stroke: "#173E9F",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M812 270H852",
    stroke: "#173E9F",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M260 270L242 257V283L260 270Z",
    fill: "#173E9F",
    transform: "translate(28 0)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M446 270L428 257V283L446 270Z",
    fill: "#173E9F",
    transform: "translate(28 0)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M656 270L638 257V283L656 270Z",
    fill: "#173E9F",
    transform: "translate(28 0)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M842 270L824 257V283L842 270Z",
    fill: "#173E9F",
    transform: "translate(28 0)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 944,
    y: 420,
    width: 154,
    height: 88,
    rx: 20,
    fill: "#ECFDF3",
    filter: "url(#shadow)"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 980,
    y: 472,
    fill: "#1A7F52",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 30,
    fontWeight: 700
  }, "Closed")), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M926 314C926 364 950 383 1000 383C1046 383 1074 393 1074 420",
    stroke: "#1A7F52",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1080 412L1067 435H1093L1080 412Z",
    fill: "#1A7F52"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 420,
    width: 186,
    height: 88,
    rx: 20,
    fill: "#FFF0F0",
    filter: "url(#shadow)"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 148,
    y: 472,
    fill: "#C62D2D",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 30,
    fontWeight: 700
  }, "Reopened")), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M896 314C896 396 800 548 520 548C320 548 236 532 210 508",
    stroke: "#C62D2D",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M219 500L198 510L221 522L219 500Z",
    fill: "#C62D2D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 364,
    y: 412,
    width: 426,
    height: 132,
    rx: 24,
    fill: "#F7FAFC",
    stroke: "#D8E2EE",
    strokeWidth: 3
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 392,
    y: 452,
    fill: "#13213F",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 26,
    fontWeight: 700
  }, "QA Notes")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 392,
    y: 490,
    fill: "#42506A",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 22
  }, "1. Attach screenshots, logs, and environment details.")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 392,
    y: 522,
    fill: "#42506A",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 22
  }, "2. Move to Retest only after fix is deployed to the correct build.")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 392,
    y: 554,
    fill: "#42506A",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 22
  }, "3. Reopen when the same issue still exists after verification.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJiraBugLifecycle);
export default __webpack_public_path__ + "static/media/jira-bug-lifecycle.225988bb4738badc7602634d09a1292f.svg";
export { ForwardRef as ReactComponent };